
/**
 * Should this be in lib?
 */
GamePayTable = (function() {
    var _payTables = [];
    var _bonusTable = false;

    function create(json) {
        var graphic = new PIXI.Graphics();

        Object.keys(resourceManager.getConfiguration().layouts).forEach(function(element) {
            if (json[element] !== undefined) {
                if (json[element].scale === undefined) {
                    json[element].scale = resourceManager.selectedAssetResolution.scale;
                } else {
                    json[element].scale *= resourceManager.selectedAssetResolution.scale;
                }
            }
        });
        return graphic;
    }

    function initialise(json, graphic) {

        var graphicWidth = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.width;
        var graphicHeight = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.height;
        var targetWidth = json.width / 2 - 4;
        var targetHeight = json.height - 4;
        var scale = (json.scale) ? json.scale : Math.min(targetWidth / graphicWidth, targetHeight / graphicHeight);

        graphic.showWinsInCurrency = json.showWinsInCurrency;
        graphic.fontDefinition = checkForDefined(json.fontDefinition) ? json.fontDefinition : "standard";
        graphic.tableWidth = json.width;
        graphic.tableHeight = json.height;
        graphic.winPlanID = json.winPlanID;
        graphic.symbolID = json.symbolID;
        graphic.fontSize = json.fontSize;
        graphic.lineStroke = 3 || json.lineStroke;
        graphic.dropShadowSize = 10 || json.dropShadowSize;

        _bonusTable = json.bonusPaytable !== "undefined" && json.bonusPaytable === true;

        // As the size of the tableWidth changes with the scale factor, the graphics needs to take account of this otherwise scale is effectively applied twice
        graphic.symbol = resourceManager.createObject("sprite", "symbolGraphic", json.FQN, { fileName: json.fileName, "x": (-graphic.tableWidth / 4) * resourceManager.selectedAssetResolution.scaleFactor, "anchor": 0.5, "scale": scale} );

        _payTables.push(graphic);
    }

    function draw(slotConfig) {
        // Store config, in case we need to change values later
        GamePayTable.slotConfig = slotConfig;

        // if there's no paytable objects Return
        if (_payTables === undefined || _payTables.length === 0) return;


        var paytable = slotConfig.data.slotConfig.prizeTable;
        if(_bonusTable){
            paytable = slotConfig.data.slotConfig.featurePrizeTable;
        } else{
            var bp = 0;
            ++bp;
        }
        // Makes some nice data to use for drawing
        // Might have to change this if the winplan naming convention changes because it uses regex on the winPlan ID strings
        _payTables.forEach(function(value, index) {
            value.uniqueID = 0;
            if (paytable[0].hasOwnProperty("phraseId")) {
                var paytablePayouts = [];
                var regex = new RegExp("_" + value.winPlanID, undefined);
                for (i = 0; i < paytable.length; ++i) {
                    if (regex.test(paytable[i].phraseId)) {
                        while (paytable[i] && regex.test(paytable[i].phraseId)) {
                            paytable[i].multiplier = Number(paytable[i].phraseId.substr(-1));
                            paytablePayouts.push(paytable[i]);
                            ++i;
                        }
                        paytablePayouts.reverse();
                        value.paytablePayouts = paytablePayouts;
                        break;
                    }
                }
            } else {
                value.paytablePayouts = paytable
                    .filter(function(x) {
                        return x.id === value.Props.symbolID;
                    })
                    .reverse();
            }

            // do some drawing

            //draw shadows
            value.lineStyle(0, 0);
            value.beginFill(0x332200, 1);
            value.drawRect(-value.tableWidth / 2 + value.dropShadowSize, -value.tableHeight / 2 + value.dropShadowSize, value.tableWidth, value.tableHeight);
            value.endFill();
            value.beginFill(0, 1);
            value.drawRect(-value.tableWidth / 2, -value.tableHeight / 2, value.tableWidth, value.tableHeight);
            value.endFill();

            var colour = 0x777722;

            // Draw outline box
            value.lineStyle(value.lineStroke, colour);
            value.drawRect(-value.tableWidth / 2, -value.tableHeight / 2, value.tableWidth, value.tableHeight);
            // Draw Dividers vertical
            value.moveTo(-value.tableWidth / 2 + value.tableWidth * 0.5, -value.tableHeight / 2);
            value.lineTo(-value.tableWidth / 2 + value.tableWidth * 0.5, -value.tableHeight / 2 + value.tableHeight);
            value.moveTo(-value.tableWidth / 2 + value.tableWidth * 0.65, -value.tableHeight / 2);
            value.lineTo(-value.tableWidth / 2 + value.tableWidth * 0.65, -value.tableHeight / 2 + value.tableHeight);
            // draw horizontal dividers
            for (var i = 1; i < value.paytablePayouts.length; i++) {
                value.moveTo(-value.tableWidth / 2 + value.tableWidth * 0.5, -value.tableHeight / 2 + value.tableHeight / value.paytablePayouts.length * i);
                value.lineTo(-value.tableWidth / 2 + value.tableWidth, -value.tableHeight / 2 + value.tableHeight / value.paytablePayouts.length * i);
            }
            // number of symbol text
            var textOffset = 1 / value.paytablePayouts.length;
            for (var j = 0; j < value.paytablePayouts.length; j++) {
                var text = resourceManager.createObject("text", getuniqueId(), value.name, {
                    x: (-value.tableWidth / 2 + value.tableWidth * 0.575) * resourceManager.selectedAssetResolution.scaleFactor,
                    y: (-value.tableHeight / 2 + value.tableHeight * (j * textOffset + textOffset * 0.5)) * resourceManager.selectedAssetResolution.scaleFactor,
                    fontDefinition: "standard",
                    maxWidth: (value.tableWidth * 0.15 - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor,
                    fontOverrides: {
                        fontSize: value.fontSize * resourceManager.selectedAssetResolution.scaleFactor
                    }
                });
                var count = paytable[0].hasOwnProperty("phraseId") ? value.paytablePayouts[j].multiplier : value.paytablePayouts[j].count;
                text.setText("x" + count);
                text.anchor.set(0.5);
            }
            // payout text
            for (var k = 0; k < value.paytablePayouts.length; k++) {
                var text = resourceManager.createObject("text", getuniqueId(), value.name, {
                    x: (-value.tableWidth / 2 + value.tableWidth * 0.825) * resourceManager.selectedAssetResolution.scaleFactor,
                    y: (-value.tableHeight / 2 + value.tableHeight * (k * textOffset + textOffset * 0.5)) * resourceManager.selectedAssetResolution.scaleFactor,
                    fontDefinition: value.fontDefinition,
                    maxWidth: (value.tableWidth * 0.35 - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor,
                    fontOverrides: {
                        fontSize: value.fontSize * resourceManager.selectedAssetResolution.scaleFactor,
                        fill: "#33FF33"
                    }
                });
                if (value.paytablePayouts[k].value > 0) {
                    text.stakeMultiplier = value.paytablePayouts[k].value / slotConfig.data.slotConfig.defaultNumLines;
                    var textValue = "x" + text.stakeMultiplier;
                    if (value.showWinsInCurrency) {
                        var stakeController = resourceManager.getController("stakeController");
                        var stake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
                        textValue = gdk.formatCurrency(text.stakeMultiplier * stake);
                    }
                    text.setText(textValue);
                    text.anchor.set(0.5);
                } else if(value.paytablePayouts[k].extraSpins !== "undefined"){
                    text.setText(value.paytablePayouts[k].extraSpins.extraspins + gdk.translateText("t_ExtraSpins",[]));
                    text.anchor.set(0.5);
                }
            }

            function getuniqueId() {
                value.uniqueID++;
                return "UniqueID" + value.uniqueID;
            }
        });

        //_payTables = null;
    }

    function onStakeChanged(newStake) {
        if (typeof(_payTables) !== "object") return;

        var nonMultipledStake = resourceManager.getController("stakeController").CurrentBetPerLine * resourceManager.getController("stakeController").CurrentWinLineCount;

        _payTables.forEach(function(value, index) {
            for (var i = 0; i < value.children.length; i++) {
                if (value.showWinsInCurrency) {
                    var item = value.children[i];
                    if (item.Props.type === "text" && checkForDefined(item.stakeMultiplier)) {
                        item.text = gdk.formatCurrency(item.stakeMultiplier * nonMultipledStake);
                    }
                }
            }
        })
    }

    function getFiles(json) {
        return [ json.fileName ];
    }

    return {
        create: create,
        initialise: initialise,
        draw: draw,
        getFiles: getFiles,
        onStakeChanged: onStakeChanged
    };
})();

resourceManager.registerObjectType("GamePayTable", GamePayTable.create, GamePayTable.initialise, GamePayTable.getFiles);
messageBus.subscribe("spinner:GameConfigEvent", GamePayTable.draw);